<template lang="pug">
  #question-preview-answer
    .block(v-if="type === 'radio'")
      div(v-for="item of getArray")
        BRadio(
          :name="item.key"
          v-model="answer"
          :native-value="item.key"
          size="is-small"
        ) {{ getAnswerValue(item) }}

    .block(v-if="type === 'checkbox'")
      div(v-for="item of getArray")
        BCheckbox(type="is-info" size="is-small") {{ getAnswerValue(item) }}

    .block(v-if="type === 'dropdown'")
      BSelect(placeholder="Select One" v-model="answer")
        option(
          v-for="item of getArray"
          :key="item.key"
          :value="item.value"
        ) {{ getAnswerValue(item) }}

    .block(v-if="type === 'text'")
      BInput(
        type="text"
        rows="2"
        class="mt-4"
      )

    .block(
      v-if="type === 'range'"
      class="is-flex is-justify-content-center is-align-items-center is-flex-wrap-wrap"
    )
      BSlider.slider(
        v-model="answer"
        :min="parseInt(rangeStart)"
        :max="parseInt(rangeEnd)"
        :class="invertSliderColor ? 'inverted-color' : null"
        indicator
        :tooltip="false"
      ).test
        BSliderTick.tick(:value="parseInt(rangeStart)") {{rangeStart}}
        BSliderTick.tick(:value="parseInt(rangeEnd)") {{rangeEnd}}


</template>

<script>
import { questionMixin } from "@/mixins/questionMixin";

export default {
  name: "QuestionPreviewAnswerAdminSuper",

  mixins: [questionMixin],

  props: {
    type: {
      type: String,
      required: true
    },
    answers: {
      type: [String, Object, Array],
      required: true
    },
    rangeStart: {
      type: String,
      default: "0"
    },
    rangeEnd: {
      type: String,
      default: "10"
    },
    invertSliderColor: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      answer: null
    };
  },

  computed: {
    getArray() {
      const array = [];

      if (typeof this.answers === "string") {
        const items = this.answers.split("\n##");
        items[0] = items[0].replace("##", "");
        items.forEach((val, index) => {
          array.push({ key: index.toString(), value: val });
        });
      } else {
        const options =
          this.type === "range" ? this.answers.values : this.answers;
        for (const [key, val] of Object.entries(options)) {
          array.push({ key: key, value: val });
        }
      }

      return array;
    }
  }
};
</script>

<style lang="sass" scoped>
.option
  margin: 10px
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  font-size: $size-small
  .b-radio.radio
    margin: 4px
.tick
  margin-top: 20px
  white-space: nowrap
  font-family: $family-sans-serif-bold
.inverted-color /deep/ .b-slider-track
  background-color: white
.slider
  margin-bottom: 40px
.b-checkbox
  /deep/ span.check
    border-radius: $radius-small !important
</style>
